/**
 * Плечи доставки, по которым назначаются тарифная карта и скидка партнёра.
 *
 * Те же четыре значения в api-calculator, slq-graph-service и api-market —
 * названия здесь только для показа оператору.
 */
export const MILE_TYPES = [
  { value: "FIRST", label: "Первая миля" },
  { value: "MIDDLE", label: "Магистраль" },
  { value: "LAST", label: "Последняя миля" },
  { value: "INTRACITY", label: "Внутригород" },
];

export const mileLabel = (value) =>
  MILE_TYPES.find((mile) => mile.value === value)?.label ?? value ?? "—";
